var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 302,
    height: 108,
    viewBox: "0 0 302 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 107.707,
    y: 10.5,
    width: 87,
    height: 87,
    rx: 43.5,
    fill: "#F7F7F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 107.707,
    y: 10.5,
    width: 87,
    height: 87,
    rx: 43.5,
    stroke: "#CECEDA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M133.207 36C132.332 36 131.613 36.2812 131.051 36.8438C130.488 37.4062 130.207 38.125 130.207 39V45H172.207V39C172.207 38.125 171.926 37.4062 171.363 36.8438C170.801 36.2812 170.082 36 169.207 36H133.207ZM130.207 48V58.5H149.707V48H130.207ZM152.707 48V58.5H172.207V48H152.707ZM149.707 61.5H130.207V69C130.207 69.875 130.488 70.5938 131.051 71.1562C131.613 71.7188 132.332 72 133.207 72H149.707V61.5ZM152.707 72H169.207C170.082 72 170.801 71.7188 171.363 71.1562C171.926 70.5938 172.207 69.875 172.207 69V61.5H152.707V72ZM127.207 39C127.27 37.3125 127.863 35.9062 128.988 34.7812C130.113 33.6562 131.52 33.0625 133.207 33H169.207C170.895 33.0625 172.301 33.6562 173.426 34.7812C174.551 35.9062 175.145 37.3125 175.207 39V69C175.145 70.6875 174.551 72.0938 173.426 73.2188C172.301 74.3438 170.895 74.9375 169.207 75H133.207C131.52 74.9375 130.113 74.3438 128.988 73.2188C127.863 72.0938 127.27 70.6875 127.207 69V39Z",
    fill: "#706B85"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDashboardIcon);
export default __webpack_public_path__ + "static/media/empty-dashboard-icon.7ce3ade10ff821dd0ac54a331110f8dc.svg";
export { ForwardRef as ReactComponent };